import { IconButtonClose } from 'components/ui';
import PropType from 'prop-types';
import injectSheet from 'react-jss';

import styles from './emailChip.style';

export function EmailChip(props) {
  const { classes, email, handleDelete } = props;
  return (
    <li className={classes.emailTag}>
      {email}
      <span className={classes.emailTagRemove}>
        <IconButtonClose
          data-testid="icon-button-close"
          onClick={() => handleDelete(email)}
        />
      </span>
    </li>
  );
}

EmailChip.propTypes = {
  classes: PropType.object.isRequired,
  email: PropType.string.isRequired,
  handleDelete: PropType.func.isRequired
};

export default injectSheet(styles)(EmailChip);
